export default __webpack_public_path__ + "static/media/le_mont9.03200ccb.jpg";